import { Typography } from '@mui/material';
import { useAtomValue } from 'jotai';

import { ICompanyDataModel } from '../../../data-models/company.data-model';
import { IListItemDataModel } from '../../../data-models/list-item.data-model';
import { ConfirmDeletionDialog } from '../../../components/Dialog/ConfirmDialog/ConfirmDeletionDialog';
import { useDeleteCompanyItemFromList } from '../Summary/hooks/useCompanyActions';
import { activeListStateJ } from '../../../services/state/ListsStateJ';

interface IListItemDeleteModalProps {
  company: ICompanyDataModel;
  item: IListItemDataModel;
  onClose: () => void;
}

export function ListItemDeleteModal({ company, item, onClose }: IListItemDeleteModalProps) {
  const deleteCompanyItemFromList = useDeleteCompanyItemFromList();
  const activeList = useAtomValue(activeListStateJ);

  const handleConfirmDelete = async () => {
    await deleteCompanyItemFromList(item.id, item.listId);
    onClose();
  };

  return (
    <ConfirmDeletionDialog
      open
      onClose={onClose}
      onConfirm={handleConfirmDelete}
      title={`Delete ${company.name} for ${activeList?.name} list?`}
    >
      <Typography variant='body2' color='text.secondary'>
        The company will be deleted from the list permanently
      </Typography>
    </ConfirmDeletionDialog>
  );
}
